
  <div class="content-wrapper">
    <div class="spacecls"></div>
    <div class="content liveCounter">
      <div class="container-fluid">
        <!-- <div class="row justify-content-center">
          <div class="col-sm-12 col-md-8 col-lg-6 col-xl-4">
            <div class="counterBox">
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="counterUpdate">
                    <div class="container-fluid">
                      <h3>Vaccination Today</h3>
                      <span class="mobileCount" [countUp]="liveVaccinationCounter" [options]="options"></span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="chartAreaWrapper-vacc">
                    <canvas *ngIf="!deviceService.isMobile() else mobileLiveVaccination"  id="liveVacc" width="400" height="200"></canvas>
                    <ng-template #mobileLiveVaccination>
                      <canvas id="liveVacc" width="200" height="100"></canvas>

                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row ">
          <!-- registration today section start  -->
          <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
            <div class="counterBox">
              <div class="row align-items-center">
                <div class="col-md-12 col-lg-12 col-xl-12 p-0">
                  <div class="counterUpdate">
                    <div class="container-fluid">
                      <h3 class="font18px">Registrations Today</h3>
                      <span class="mobileCount countColorgray font22px" [countUp]="totalRegistrationCounter" [options]="options">0</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-12 col-xl-12 p-0">
                  <div class="chartAreaWrapper-vacc">
                    <canvas *ngIf="!deviceService.isMobile() else mobileLiveVaccinationStreamingReg"  id="liveVaccStreamingReg" width="295" height="100"></canvas>
                    <ng-template #mobileLiveVaccinationStreamingReg>
                      <canvas id="liveVaccStreamingReg" width="295" height="100"></canvas>
                    </ng-template>
                    <!-- <p class="text-center m-0">5 Mins Interval</p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- registration today section start  -->
            <div class="col-sm-12 col-md-6 col-lg-9 col-xl-9 padlr6px mb-3">
              <div class='row'>
              <!-- vaccination today section start  -->
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 padlr15px mb-3">
                <div class="counterBox">
                  <div class="row align-items-center">
                    <div class="col-md-7 col-lg-7 col-xl-7 p-0">
                      <div class="counterUpdate">
                        <div class="container-fluid">
                          <h3>Vaccinations Today</h3>
                          <span class="mobileCount countColorbiscay" [countUp]="totalVaccinationCounter" [options]="options">0</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5 col-lg-5 col-xl-5 p-0">
                      <div class="chartAreaWrapper-vacc">
                        <canvas *ngIf="!deviceService.isMobile() else mobileLiveVaccinationStreaming"  id="liveVaccStreaming" width="120" height="50"></canvas>
                        <ng-template #mobileLiveVaccinationStreaming>
                          <canvas id="liveVaccStreaming" width="120" height="50"></canvas>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- vaccination today section start  -->

              <!-- Partially Vaccinated Today section start  -->
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 padlr15px mb-3">
                <div class="counterBox">
                  <div class="row align-items-center">
                    <div class="col-md-7 col-lg-7 col-xl-7 p-0">
                      <div class="counterUpdate">
                        <div class="container-fluid">
                          <h3>Partially Vaccinated Today</h3>
                          <span class="mobileCount countColororange" [countUp]="partialVaccinationCounter" [options]="options">0</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5 col-lg-5 col-xl-5 p-0">
                      <div class="chartAreaWrapper-vacc">
                        <canvas *ngIf="!deviceService.isMobile() else mobileLiveVaccinationStreamingPartialVacc"  id="liveVaccStreamingPartialVacc" width="120" height="50"></canvas>
                        <ng-template #mobileLiveVaccinationStreamingPartialVacc>
                          <canvas id="liveVaccStreamingPartialVacc" width="120" height="50"></canvas>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Partially Vaccinated Today section start  -->


              <!-- Fully Vaccinated Today section start  -->
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 padlr15px mb-3">
                <div class="counterBox">
                  <div class="row align-items-center">
                    <div class="col-md-7 col-lg-7 col-xl-7 p-0">
                      <div class="counterUpdate">
                        <div class="container-fluid">
                          <h3>Fully Vaccinated Today</h3>
                          <span class="mobileCount countColormantis" [countUp]="fullyVaccinationCounter" [options]="options">0</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5 col-lg-5 col-xl-5 p-0">
                      <div class="chartAreaWrapper-vacc">
                        <canvas *ngIf="!deviceService.isMobile() else mobileLiveVaccinationStreamingFullyVacc"  id="liveVaccStreamingFullyVacc" width="120" height="50"></canvas>
                        <ng-template #mobileLiveVaccinationStreamingFullyVacc>
                          <canvas id="liveVaccStreamingFullyVacc" width="120" height="50"></canvas>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <!-- Fully Vaccinated Today section start  -->

            <!-- 15-17 Vaccinations Today Start -->
              <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 padlr15px mb-3">
                <div class="counterBox">
                  <div class="row align-items-center">
                    <div class="col-md-7 col-lg-7 col-xl-7 p-0">
                      <div class="counterUpdate">
                        <div class="container-fluid">
                          <h3>15-17 Vaccinations Today</h3>
                          <span class="mobileCount countColorgray" [countUp]="total15_17Vaccination" [options]="options">0</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-5 col-lg-5 col-xl-5 p-0">
                      <div class="chartAreaWrapper-vacc">
                        <canvas *ngIf="!deviceService.isMobile() else mobile15_17Vacc"  id="liveVacc15_17" width="120" height="50"></canvas>
                        <ng-template #mobile15_17Vacc>
                          <canvas id="liveVacc15_17" width="120" height="50"></canvas>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <!-- 15-17 Vaccinations Today End -->

            <!-- HCW/FLW Precaution Vaccinations Today Start -->
            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 padlr15px mb-3">
              <div class="counterBox">
                <div class="row align-items-center">
                  <div class="col-md-7 col-lg-7 col-xl-7 p-0">
                    <div class="counterUpdate">
                      <div class="container-fluid">
                        <h3>HCW/FLW Precaution Doses Today</h3>
                        <span class="mobileCount countColorbiscay" [countUp]="total_hcw_flw_precaution_vaccinations" [options]="options">0</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 col-lg-5 col-xl-5 p-0">
                    <div class="chartAreaWrapper-vacc">
                      <canvas *ngIf="!deviceService.isMobile() else mobile18_44Vacc"  id="liveVacc18_44" width="120" height="50"></canvas>
                      <ng-template #mobile18_44Vacc>
                        <canvas id="liveVacc18_44" width="120" height="50"></canvas>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- HCW/FLW Precaution Vaccinations Today end -->

            <!-- 60+ Precaution Vaccinations Today Start -->
            <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4 padlr15px mb-3">
              <div class="counterBox">
                <div class="row align-items-center">
                  <div class="col-md-7 col-lg-7 col-xl-7 p-0">
                    <div class="counterUpdate">
                      <div class="container-fluid">
                        <h3>60+ Precaution Doses Today</h3>
                        <span class="mobileCount countColororange" [countUp]="total_60_plus_precaution_vaccinations" [options]="options">0</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 col-lg-5 col-xl-5 p-0">
                    <div class="chartAreaWrapper-vacc">
                      <canvas *ngIf="!deviceService.isMobile() else mobile45_60Vacc"  id="liveVacc45_60" width="120" height="50"></canvas>
                      <ng-template #mobile45_60Vacc>
                        <canvas id="liveVacc45_60" width="120" height="50"></canvas>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 60+ Precaution Vaccinations Today End -->
            </div>
          </div>
        </div>


        <!-- <div class="row ">
          <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
            <div class="counterBox">
              <div class="row align-items-center">
                <div class="col-md-7 col-lg-7 col-xl-7 p-0">
                  <div class="counterUpdate">
                    <div class="container-fluid">
                      <h3>15-17 Vaccinations Today</h3>
                      <span class="mobileCount countColorgray" [countUp]="total15_17Vaccination" [options]="options">0</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-5 col-lg-5 col-xl-5 p-0">
                  <div class="chartAreaWrapper-vacc">
                    <canvas *ngIf="!deviceService.isMobile() else mobile15_17Vacc"  id="liveVacc15_17" width="120" height="50"></canvas>
                    <ng-template #mobile15_17Vacc>
                      <canvas id="liveVacc15_17" width="120" height="50"></canvas>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>

             <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox">
                <div class="row align-items-center">
                  <div class="col-md-7 col-lg-7 col-xl-7 p-0">
                    <div class="counterUpdate">
                      <div class="container-fluid">
                        <h3>HCW/FLW Precaution Doses</h3>
                        <span class="mobileCount countColorbiscay" [countUp]="total_hcw_flw_precaution_vaccinations" [options]="options">0</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 col-lg-5 col-xl-5 p-0">
                    <div class="chartAreaWrapper-vacc">
                      <canvas *ngIf="!deviceService.isMobile() else mobile18_44Vacc"  id="liveVacc18_44" width="120" height="50"></canvas>
                      <ng-template #mobile18_44Vacc>
                        <canvas id="liveVacc18_44" width="120" height="50"></canvas>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 padlr15px mb-3">
              <div class="counterBox">
                <div class="row align-items-center">
                  <div class="col-md-7 col-lg-7 col-xl-7 p-0">
                    <div class="counterUpdate">
                      <div class="container-fluid">
                        <h3>60+ Precaution Doses</h3>
                        <span class="mobileCount countColororange" [countUp]="total_60_plus_precaution_vaccinations" [options]="options">0</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-5 col-lg-5 col-xl-5 p-0">
                    <div class="chartAreaWrapper-vacc">
                      <canvas *ngIf="!deviceService.isMobile() else mobile45_60Vacc"  id="liveVacc45_60" width="120" height="50"></canvas>
                      <ng-template #mobile45_60Vacc>
                        <canvas id="liveVacc45_60" width="120" height="50"></canvas>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div> -->

    <div class="col-md-12 clearfix">
      <nav aria-label="breadcrumb" class="cm-breadcrumb">
        <ol class="breadcrumb breadcrumb_dashboard">
        <li>
          <span class="fontnormal"><img src="assets/images/home_india.svg" class="home_india"></span>
        </li>
        <ng-container *ngIf="breadCrumbArr.length == 0">
          <li class="breadcrumb-item accessibility-plugin-ac"> India</li>
        </ng-container>
        <li *ngFor="let b of breadCrumbArr; let isLast=last;"
          class="breadcrumb-item"
          [ngClass]="{'active' : isLast}"
          >
          <a *ngIf="!isLast" class="accessibility-plugin-ac" (click)="headerTextLbl= b.type;nextLevel(b.type, state_id, district_id)">{{b.name}}</a>
          <a *ngIf="isLast" class="accessibility-plugin-ac">{{b.name}}</a>
        </li>
        </ol>
      </nav>




      <div class="cm-state-wrap">
        <div class="cm-state" >

          <!-- <select name="states" id="state" class= "dropdown_states" (change)="getNewDashboardData($event.target.value,'')"> -->
            <select name="states" id="state" class= "dropdown_states accessibility-plugin-ac" (change)="loadDataByStateTab($event.target.value,'')">

            <option value = "" class="accessibility-plugin-ac">{{'SLOT_SEARCH.Select_State' | translate}}</option>
            <option *ngFor="let state of states" [value]="state.state_id" class="accessibility-plugin-ac">{{state.state_name}}</option>
          </select>
        </div>

       <div class=" cm-district">
        <!-- <select name="districtList" id="district" class= "dropdown_districts" (change)="getNewDashboardData(state_id,$event.target.value)">
          <option value = "">Select District</option>
          <option *ngFor="let district of districtListfromstate" [value]="district.district_id" >{{district.district_name}}</option>
         </select> -->
         <!-- <select name="districtList" id="district" class= "dropdown_districts" (change)="getNewDashboardDataforDistrict($event.target.value)"> -->
          <select name="districtList" id="district" class= "dropdown_districts accessibility-plugin-ac" (change)="loadDataByDitrictTab($event.target.value)">
          <option value = "" class="accessibility-plugin-ac">{{'SLOT_SEARCH.Select_District' | translate}}</option>
          <option *ngFor="let district of districtListfromstate" [value]="district.district_id" class="accessibility-plugin-ac">{{district.district_name}}</option>
         </select>
       </div>
      </div>

    </div>
    <div class="col-md-12 clearfix">
      <div class="dropdown export-drop-down">
        <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          Export
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" (click)="ExportDashboardDataInJson()">Json</a>
          <a class="dropdown-item" (click)="ExportDashboardDataInExcel()">Excel</a>
        </div>
      </div>
  </div>
 <!-- <section class="counter  mb-4 mt-4">
   <div class="container-fluid">
     <div class="row">
       <div class="col-sm-12">
         <span class="countHeading">Vacccination Today</span>
         <div class="vaccinationCount">
          <span class="mobileCount" [countUp]="liveVaccinationCounter" [options]="options"></span>
          </div>
       </div>
     </div>
   </div>
 </section> -->

 <section class="countertext">
  <div class="container-fluid">
  
    <div class="row">
      <div class="col-sm-6 mb-2">
        <!-- <span class="countHeading">Vacccination Today</span> -->
   <p >*<i>The figure displayed in the dose counter are provisional and are subject to reconciliation.</i></p>
   <p>*<i>The figures for 18 years old (birth year 2004) are included in 18-44 age group.</i></p>
      </div>

      <div class="col-sm-6 mb-2 lastupdatedtext">
        <!-- <span class="countHeading">Vacccination Today</span> -->
   <p>Last updated : {{ReportGenerateTime | date:'yyyy/M/d hh:mm aa'}}</p>
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-sm-6 mb-2">
       
      </div>
    </div> -->
  </div>
</section>
 <section class="content">
      <div class="container-fluid main-card-block">

        <div class="row">
          <div class="col-6  col-sm-12 margin-b cardblockcls"  [ngClass]="(state_id || district_id)?'col-lg-6':'col-lg-4'">
            <div class="small-box bg-white cm-vaccinated-box">
              <div class="icon icon-bg-vaccine">
                <span class="icon-vaccine"></span>
              </div>
             <div class="inner innerbox">

                <p  *ngIf="counterFlag" class="small todayvalue  text-right mb-0">
                   <span class="fontnormal accessibility-plugin-ac">
                  <!--<img class="calicon" src="assets/images/icon_calander.svg">-->  {{'DASHBOARD.Today' | translate}}:</span> <strong class="greencolor"> {{topBlockReport?.vaccination?.today | numberFormat}}</strong></p>
                <p class="fontnormal titlemob accessibility-plugin-ac">{{'DASHBOARD.Total_Vaccination_Doses' | translate}}
                  <!-- <span tooltip="Total number of doses administered till date includes 34,47,894 doses administered to the Personnel of Ministries of Home Affairs and Defence." aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom"> -->
                    <span tooltip="Total number of doses administered till date includes 41,79,128 doses administered outside CoWIN"
                     aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
                    <img class="infoicon" src="assets/images/info_icon.svg">
                    </span>
                </p>
                <h3 class="accessibility-plugin-ac">{{topBlockReport?.vaccination?.total_doses | numberFormat}}</h3>

              <div class="row m-0 r-0 w-100">
                <div class="col pl-0">
                  <small class="text-muted accessibility-plugin-ac">{{'DASHBOARD.Dose_1' | translate}}</small>
                    <p class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac">{{topBlockReport?.vaccination?.tot_dose_1 | numberFormat}}</p>

                </div>
                <div class="col pr-0">
                  <small class="text-muted accessibility-plugin-ac">{{'DASHBOARD.Dose_2' | translate}}</small>
                    <p class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac">{{topBlockReport?.vaccination?.tot_dose_2 | numberFormat}}</p>

                </div>
                <div class="col pr-0">
                  <small class="text-muted accessibility-plugin-ac">Precaution Dose</small>
                    <p class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac">{{topBlockReport?.vaccination?.tot_pd | numberFormat}}</p>

                </div>
            </div>
            </div>
            </div>
          </div>
          <!-- <div class="col-lg-3 cardblockcls col-6 margin-b"> -->
            <div class="col-6  col-sm-12 margin-b cardblockcls"  [ngClass]="(state_id || district_id)?'col-lg-6':'col-lg-4'">
            <div class="small-box bg-white dash-box cm-site-conduct-box">
              <div class="icon">
                <!-- <span class="icon-center"></span> -->
                <img src="assets/images/building.png" alt="sites" class="img-fluid img_icon"/>
              </div>
              <div class="inner innerbox">
                <!-- <p class="small todayvalue  text-right mb-0"><span class="fontnormal">Today : </span><strong>{{topBlockReport?.sites?.today | numberFormat}}</strong></p> -->
                <!-- <p class="small todayvalue  text-right mb-0"><span class="fontnormal">Today</span></p> -->
                <p class="fontnormal titlemob accessibility-plugin-ac">
                  {{'DASHBOARD.Sites_Conducting_Vaccination' | translate}}
                 <span tooltip="Total private health facilities & public health facilities conducting vaccination today."
                 aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
                <img class="infoicon" src="assets/images/info_icon.svg">
                </span>
              <!-- <span><button type="button" class="btn btn-primary"
                tooltip="Vivamus sagittis lacus vel augue laoreet rutrum faucibus.">
          Simple demo
        </button> </span>  -->
                </p>
                <h3 class="accessibility-plugin-ac"> <span class="fontnormal cls_today"></span>{{topBlockReport?.sites?.total| numberFormat}}</h3>

                <div class="row m-0 r-0 w-100">
                  <div class="col pl-0">
                    <small class="text-muted accessibility-plugin-ac">{{'DASHBOARD.Government' | translate}}</small>
                      <p class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac">{{topBlockReport?.sites?.govt | numberFormat}}</p>

                  </div>
                  <div class="col pr-0">
                    <small class="text-muted accessibility-plugin-ac">{{'DASHBOARD.Private' | translate}}</small>
                      <p class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac">{{topBlockReport?.sites?.pvt | numberFormat}}</p>

                  </div>
              </div>
              </div>
            </div>
          </div>


          <div class="col-lg-4  col-sm-12 cardblockcls col-6 margin-b" *ngIf="!this.state_id">

            <div class="small-box bg-white dash-box cm-reg-box">
              <div class="row">


                <div class="icon icon-bg-beneficiary">
                  <!-- <span class="icon-beneficiary"></span> -->
                  <img src="assets/images/group.png" alt="sites" class="img-fluid img_icon"/>
                </div>



            </div>
              <div class="inner innerbox" >
                <!-- <p class="small todayvalue  text-right mb-0"><span class="fontnormal accessibility-plugin-ac">
                  {{'DASHBOARD.Today' | translate}}:</span>
                   <strong class="greencolor"> {{topBlockReport?.registration?.today | numberFormat}}</strong></p> -->
                <p class="fontnormal titlemob accessibility-plugin-ac">{{'DASHBOARD.Total_Registrations' | translate}}
                <span tooltip="Total number of beneficiaries registered via online & offline mode till date,
                including Front Line Workers(FLW) & Health Care Workers(HCW) "
                aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
                  <img class="infoicon" src="assets/images/info_icon.svg">
                  </span>

                </p>

                <h3 class="accessibility-plugin-ac">{{topBlockReport?.registration?.total | numberFormat}}</h3>


            <div class="row m-0 r-0 w-100">
              <div class="col pl-0">
                <small class="text-muted accessibility-plugin-ac">Age 15-17</small>
                  <p class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac">{{topBlockReport?.registration?.cit_15_17 | numberFormat}}</p>

              </div>
              <div class="col pl-0">
                <small class="text-muted accessibility-plugin-ac">{{'DASHBOARD.Age_18-44' | translate}}</small>
                  <p class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac">{{topBlockReport?.registration?.cit_18_45 | numberFormat}}</p>

              </div>
              <div class="col pr-0">
                <small class="text-muted accessibility-plugin-ac">{{'DASHBOARD.Age_45+' | translate}}</small>
                  <p class="d-block mb-0 font-weight-bold font-2 accessibility-plugin-ac">{{topBlockReport?.registration?.cit_45_above | numberFormat}}</p>

              </div>
          </div>

            </div>
            </div>
          </div>


        </div>

        <!-- <div class="row">
          <section  class="col-lg-12 connectedSortable cm-vc-trends">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac">
                 Vaccination
                </h3>
              </div>
              <div class="card-body">
                <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else mobileLiveVaccination"  id="liveVacc" width="600" height="160"></canvas>
                <ng-template #mobileLiveVaccination>
                  <canvas id="liveVacc" width="600" height="400"></canvas>
                </ng-template>
              </div>
            </div>
              </div>
            </div>
          </section>
        </div> -->

        <div class="row">

          <section  class="col-lg-12 connectedSortable cm-vc-trends">
            <div class="card">

              <div class="card-header">


                <h3 class="card-title blocktitle accessibility-plugin-ac">
                  {{'DASHBOARD.Vaccination_Trends' | translate}}
                  <span [hidden]="(!isday && !isdayVacc)" tooltip="Vaccination trend for today."
                 aria-label="Button that displays a tooltip when focused or hovered over" class="accessibility-plugin-ac" placement="bottom">
                <img class="infoicon" src="assets/images/info_icon.svg">
                </span>
                <span [hidden]="(!ismonth && !ismonthVacc)" tooltip="Vaccination trend for last 30 days."
                aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
               <img class="infoicon" src="assets/images/info_icon.svg">
               </span>
               <span [hidden]="(!isweek && !isweekVacc)" tooltip="Vaccination trend since beginning"
               aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
              <img class="infoicon" src="assets/images/info_icon.svg">
              </span>
                </h3>

                 </div>
                 <div class="card-header">

                    <div class="cm-bttn-wrap-new clearfix">
                      <ul>
                        <li [ngClass]="{'active' : isByDoses }">
                          <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getVaccByTab('By Doses')">
                            {{'DASHBOARD.By_Doses' | translate}}
                           </button>
                        </li>
                        <li [ngClass]="{'active' : isByAge }">
                          <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getVaccByTab('By Age')">
                            {{'DASHBOARD.By_Age' | translate}}
                           </button>
                        </li>
                        <!-- <li [ngClass]="{'active' : isByCategory }">
                          <button type="button" class="btn btn-tool" (click)="getVaccByTab('By Category')">
                           By Category
                           </button>
                        </li> -->

                      </ul>
                    </div>

                    <div [hidden]="!isByDoses">
                      <div class="cm-bttn-wrap clearfix">
                        <ul>
                          <li [ngClass]="{'active' : isday }">
                            <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getVaccByTab('isday')">
                              {{'DASHBOARD.Today' | translate}}
                             </button>
                             <!-- <button type="button" class="btn btn-tool" (click)="getNewDashboardData(state_id,district_id)">
                              Today
                             </button> -->
                          </li>
                          <li [ngClass]="{'active' : ismonth }">
                            <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getVacChartData('Last 30 Days')">
                              {{'DASHBOARD.Last_30_Days' | translate}}
                             </button>
                          </li>
                          <li [ngClass]="{'active' : isweek }">
                            <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getVacChartDataAll('All')">
                              {{'DASHBOARD.All' | translate}}
                              </button>

                          </li>
                        </ul>
                    </div>

                      <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                          <i class="fas fa-minus"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-card-widget="remove">
                          <i class="fas fa-times"></i>
                        </button>
                      </div>

                    </div>
                    <div [hidden]="!isByAge">
                      <div class="cm-bttn-wrap clearfix">
                        <ul>
                          <li [ngClass]="{'active' : isdayVacc }">
                            <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getVaccChartAgewiseDataToday('Today')">
                              {{'DASHBOARD.Today' | translate}}
                             </button>
                          </li>
                          <li [ngClass]="{'active' : ismonthVacc }">
                            <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getVaccChartAgewiseDataMonth('Last 30 Days')">
                              {{'DASHBOARD.Last_30_Days' | translate}}
                             </button>
                          </li>
                          <li [ngClass]="{'active' : isweekVacc }">
                            <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getVaccChartAgewiseDataAll('All')">
                              {{'DASHBOARD.All' | translate}}
                              </button>

                          </li>
                        </ul>
                    </div>

                    </div>


                 </div>


              <div class="card-body" [hidden]="!isday">

                <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else mobileRealtimeCNVS"  id="realtime" width="600" height="160"></canvas>
                <ng-template #mobileRealtimeCNVS>
                  <canvas id="realtime" width="600" height="400"></canvas>
                </ng-template>
              </div>
            </div>
              </div>


              <div class="card-body" [hidden]="!ismonth">
                <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else mobileRealtimeCNVSmonth"  id='realtimemonth' width="200" height="50"></canvas>
                <ng-template #mobileRealtimeCNVSmonth>
                      <canvas id="realtimemonth" width="600" height="300"></canvas>
                </ng-template>
              </div>
              </div>
            </div>


              <div class="card-body" [hidden]="!isweek">
                <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else mobileRealtimeCNVSweek"  id='realtimeweek' width="200" height="50"></canvas>
                <ng-template #mobileRealtimeCNVSweek>
                      <canvas id="realtimeweek" width="600" height="300"></canvas>
                </ng-template>
              </div>
              </div>
            </div>

            <div class="card-body" [hidden]="(!isdayVacc)">
              <div class="chart-mob-scroll cm-scrollbar">
              <div class="chartAreaWrapper">
              <canvas *ngIf="!deviceService.isMobile() else VaccAgewiseToday"  id='vacc-agewise-today' width="200" height="50"></canvas>
              <ng-template #VaccAgewiseToday>
                    <canvas id="vacc-agewise-today" width="600" height="300"></canvas>
              </ng-template>
            </div>
            </div>
          </div>

            <div class="card-body" [hidden]="(!ismonthVacc)">
              <div class="chart-mob-scroll cm-scrollbar">
              <div class="chartAreaWrapper">
              <canvas *ngIf="!deviceService.isMobile() else VaccAgewiseMonth"  id='vacc-agewise-month' width="200" height="50"></canvas>
              <ng-template #VaccAgewiseMonth>
                    <canvas id="vacc-agewise-month" width="600" height="300"></canvas>
              </ng-template>
            </div>
            </div>
          </div>

          <div class="card-body" [hidden]="(!isweekVacc)">
            <div class="chart-mob-scroll cm-scrollbar">
            <div class="chartAreaWrapper">
            <canvas *ngIf="!deviceService.isMobile() else VaccAgewiseAll"  id='vacc-agewise-all' width="200" height="50"></canvas>
            <ng-template #VaccAgewiseAll>
                  <canvas id="vacc-agewise-all" width="600" height="300"></canvas>
            </ng-template>
          </div>
          </div>
        </div>

        <!-- <div class="card-body" [hidden]="(!isByCategory)">
          <div class="chart-mob-scroll cm-scrollbar">
          <div class="chartAreaWrapper">
          <canvas *ngIf="!deviceService.isMobile() else VaccCategoryWise"  id='vacc-bycategory' width="200" height="50"></canvas>
          <ng-template #VaccCategoryWise>
                <canvas id="vacc-bycategory" width="600" height="300"></canvas>
          </ng-template>
        </div>
        </div>
      </div> -->

            </div>
          </section>

        </div>

        <!-- <div class="row">
          <section class="col-lg-12 connectedSortable cm-vc-trends chart-mob-scroll">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle w-ltd">Vaccination UpTrends

                </h3>

                 <div class="cm-bttn-wrap clearfix">
                  <ul>
                    <li [ngClass]="{'active' : isupTrendToday }">
                      <button type="button" class="btn btn-tool" (click)="getVaccByTab('By Uptrends')">
                        Today
                       </button>


                    </li>
                    <li [ngClass]="{'active' : isupTrendMonth }">
                      <button type="button" class="btn btn-tool" (click)="getUptrendVacChartDataMonth('Last 30 Days')">
                        Last 30 Days
                       </button>



                    </li>
                    <li [ngClass]="{'active' : isupTrendAll }">
                      <button type="button" class="btn btn-tool" (click)="getUptrendVacChartDataAll('All')">
                        All
                        </button>



                    </li>
                  </ul>

              </div>


                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body" [hidden]="(!isupTrendToday)">
                <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else mobileVaccUptrends"  id="vacc-uptrends" width="200" height="50"></canvas>
                  <ng-template #mobileVaccUptrends>
                    <canvas id="vacc-uptrends" width="600" height="300"></canvas>
                  </ng-template>
                  </div>
                  </div>
              </div>

              <div class="card-body" [hidden]="(!isupTrendMonth)">
                <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else mobileVaccUptrendsMonth"  id="vacc-uptrends-month" width="200" height="50"></canvas>
                  <ng-template #mobileVaccUptrendsMonth>
                    <canvas id="vacc-uptrends-month" width="600" height="300"></canvas>
                  </ng-template>
                  </div>
                  </div>
              </div>

              <div class="card-body" [hidden]="(!isupTrendAll)">
                <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else mobileVaccUptrendsWeek"  id="vacc-uptrends-week" width="200" height="50"></canvas>
                  <ng-template #mobileVaccUptrendsWeek>
                    <canvas id="vacc-uptrends-week" width="600" height="300"></canvas>
                  </ng-template>
                  </div>
                  </div>
              </div>
            </div>
          </section>


        </div> -->

        <div class="row">
          <section class="col-lg-3 connectedSortable">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac">
                  {{'DASHBOARD.Vaccination_Category' | translate}}
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                  <canvas *ngIf="!deviceService.isMobile() else genderPieCanvas"  id='total-vaccinated-gender' width="240" height="100"></canvas>
                  <ng-template #genderPieCanvas>
                    <canvas id="total-vaccinated-gender" width="600" height="400"></canvas>
                  </ng-template>


                  <canvas *ngIf="!deviceService.isMobile() else materialPieCanvas"  id='material-used' width="240" height="100"></canvas>
                  <ng-template #materialPieCanvas>
                    <canvas id="material-used" width="600" height="400"></canvas>
                  </ng-template>
              </div>
            </div>
          </section>

          <section class="col-lg-4 connectedSortable">


            <div class="card">
              <div class="card-header">
                <h3 class="card-title mb-0 blocktitle accessibility-plugin-ac"> {{'DASHBOARD.Vaccination_by_Age' | translate}}</h3>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <canvas *ngIf="!deviceService.isMobile() else mobilevaccinationbyage" 
                 id="vaccination-by-age" width="600" height="365"></canvas>
                  <ng-template #mobilevaccinationbyage>
                    <canvas id="vaccination-by-age" width="600" height="400"></canvas>
                  </ng-template>
              </div>
            </div>

          </section>

          <section class="col-lg-5 connectedSortable">

            <div class="card">
              <div class="card-header">

                  <h3 class="card-title blocktitle mb-0 accessibility-plugin-ac" style="width:100%;">
                    <!-- Vaccination By State/UT -->
                    {{'DASHBOARD.Vaccination_By' | translate}}{{tableheader}}
                    <!-- <span class="badge badge-primary float-right py-2 px-3"
                                style="background-color: #5a8dee;">Till: {{todaysdate | date: 'dd/MM/yyyy'}}</span> -->
                  </h3>

              </div>
              <div class="card-body tbl_card nopading">
                <div id="data-list" class="slim">
                  <table class="table tblstates mb-0">
                    <thead class="tbl-head">
                      <th class="header accessibility-plugin-ac">{{tableheader}}<i (click)="onSortClick($event,'title')" class="my-icon fa fa-chevron-up"></i></th>
                      <th class="header accessibility-plugin-ac" style="text-align: right;"> {{'DASHBOARD.Today' | translate}}<i (click)="onSortClick($event,'today')" class="my-icon fa fa-chevron-up"></i></th>
                      <th class="header accessibility-plugin-ac"style="text-align: right;"> {{'DASHBOARD.Total' | translate}}<i (click)="onSortClick($event,'total')" class="my-icon fa fa-chevron-up"></i></th>
                    </thead>
                    <tbody class="table-body rep-tb-body">

                      <!-- <tr *ngFor="let benData of getBeneficiariesGroupBy" (click)="headerTextLbl != 'Center' && nextLevel(headerTextLbl,benData.state_id,benData.district_id)"> -->
                        <tr *ngFor="let benData of getBeneficiariesGroupBy" >
                        <!-- <tr *ngFor="let benData of getBeneficiariesGroupBy"> -->
                        <td class="title accessibility-plugin-ac" style="width: 50%; font-size: 13px; color: #007bff;; font-weight: 500;">{{benData.title}}</td>
                        <td style="width: 25%;font-size: 15px;color: #12226f;font-weight: 600;"  class="text-right accessibility-plugin-ac">{{benData.today | numberFormat}}</td>
                        <td style="width: 25%;font-size: 15px;color: #12226f;font-weight: 600;" class="text-right accessibility-plugin-ac">
                        <!-- <span class="todayclsforstat">Today:{{benData.today | numberFormat}}</span> -->
                         {{benData.total | numberFormat}}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
          </div>
        </section>

        </div>


        <div class="row">
          <section class="col-lg-6 connectedSortable chart-mob-scroll">
            <div class="card ">
              <div class="card-header">
                <h3 class="card-title blocktitle w-ltd accessibility-plugin-ac" style="max-width: 280px;">{{'HOME.AEFI_REPORTED' | translate}} <span tooltip="Adverse Event Following Immunization"
                  aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
                 <img class="infoicon" src="assets/images/info_icon.svg">
                 </span></h3>
                 <div class="cm-bttn-wrap clearfix accessibility-plugin-ac">
                <span style="font-weight: bold;">{{'DASHBOARD.Overall' | translate}} : {{ vaccinatedAefiPer }} %</span>
                 </div>
                <div class="card-tools">
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="collapse"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-tool"
                    data-card-widget="remove"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else mobileVaccAefiLast7days"  id="vaccination-aefi-seven-days" width="600" height="240"></canvas>
                  <ng-template #mobileVaccAefiLast7days>
                    <canvas id="vaccination-aefi-seven-days" width="600" height="400"></canvas>
                  </ng-template>
                  </div>
                  </div>
              </div>
            </div>
          </section>

          <!-- <section class="col-lg-6 connectedSortable chart-mob-scroll">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle accessibility-plugin-ac">
                  Session Trends <span tooltip="No. of vaccination sessions conducted"
                  aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
                 <img class="infoicon" src="assets/images/info_icon.svg">
                 </span>
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
                <div class="card-body">
                <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else last5days"  id="Last5daysCenterAnalysis" width="600" height="240"></canvas>
                <ng-template #last5days>
                  <canvas id="Last5daysCenterAnalysis" width="600" height="400"></canvas>

                </ng-template>
              </div>
              </div>
              </div>
            </div>
          </section> -->


          <section class="col-lg-6 connectedSortable chart-mob-scroll">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title blocktitle">
                  {{'DASHBOARD.Rural_Vs_Urban_Trend' | translate}}
                </h3>
                <div class="card-tools">
                  <button type="button" class="btn btn-tool" data-card-widget="collapse">
                    <i class="fas fa-minus"></i>
                  </button>
                  <button type="button" class="btn btn-tool" data-card-widget="remove">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <!-- <div class="card-body">
                <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else last5days"  id="Last5daysCenterAnalysis" width="600" height="240"></canvas>
                <ng-template #last5days>
                  <canvas id="Last5daysCenterAnalysis" width="600" height="400"></canvas>

                </ng-template>
              </div>
              </div>
              </div> -->

              <div class="card-body">
          <div class="chart-mob-scroll cm-scrollbar">
          <div class="chartAreaWrapper">
          <canvas *ngIf="!deviceService.isMobile() else VaccCategoryWise"  id='vacc-bycategory' width="600" height="240"></canvas>
          <ng-template #VaccCategoryWise>
                <canvas id="vacc-bycategory" width="600" height="400">></canvas>
          </ng-template>
        </div>
        </div>
      </div>
            </div>
          </section>
        </div>

          <div class="row" *ngIf="!chartFlag">

            <section class="col-lg-12 connectedSortable chart-mob-scroll">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title blocktitle accessibility-plugin-ac"> {{'DASHBOARD.Vaccination_Coverage' | translate}}</h3>
                  <div class="card-tools">
                    <button
                      type="button"
                      class="btn btn-tool"
                      data-card-widget="collapse"
                    >
                      <i class="fas fa-minus"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-tool"
                      data-card-widget="remove"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body">
                  <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                  <canvas *ngIf="!deviceService.isMobile() else vaccCoverageByStateCanvas"  id='vaccination-coverage-by-state' width="200" height="50"></canvas>
                  <ng-template #vaccCoverageByStateCanvas>
                        <canvas id="vaccination-coverage-by-state" width="600" height="400"></canvas>
                  </ng-template>
                </div>
                </div>
              </div>

            </div>
            </section>
          </div>
          <div class="row" *ngIf="!this.state_id">
            <section  class="col-lg-12 connectedSortable cm-vc-trends chart-mob-scroll">
              <div class="card">
                <div class="card-header">
                  <h3 class="card-title blocktitle accessibility-plugin-ac">
                    {{'DASHBOARD.Registration_Trends' | translate}}
                    <span [hidden]="!isdayReg" tooltip="Registration trend for today."
                   aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
                  <img class="infoicon" src="assets/images/info_icon.svg">
                  </span>
                  <span [hidden]="!ismonthReg" tooltip="Registration trend for last 30 days."
                  aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
                 <img class="infoicon" src="assets/images/info_icon.svg">
                 </span>
                 <span [hidden]="!isweekReg" tooltip="Registration trend since beginning"
                 aria-label="Button that displays a tooltip when focused or hovered over" placement="bottom">
                <img class="infoicon" src="assets/images/info_icon.svg">
                </span>
                  </h3>
                  <div class="cm-bttn-wrap clearfix">
                    <ul>
                      <li [ngClass]="{'active' : isdayReg }">
                        <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getVaccByTab('isdayReg')">
                          {{'DASHBOARD.Today' | translate}}
                         </button>


                      </li>
                      <li [ngClass]="{'active' : ismonthReg }">
                        <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getRegChartDataMonth('Last 30 Days')">
                          {{'DASHBOARD.Last_30_Days' | translate}}
                         </button>
                      </li>
                      <li [ngClass]="{'active' : isweekReg }">
                        <button type="button" class="btn btn-tool accessibility-plugin-ac" (click)="getRegChartDataAll('All')">
                          {{'DASHBOARD.All' | translate}}
                          </button>



                      </li>
                    </ul>

                </div>


                  <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse">
                      <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
                <div class="card-body" [hidden]="!isdayReg">
                  <div class="chart-mob-scroll cm-scrollbar">
                    <div class="chartAreaWrapper">
                  <canvas *ngIf="!deviceService.isMobile() else mobileRealtimereg"  id="realtimeregchart" width="600" height="160"></canvas>
                  <ng-template #mobileRealtimereg>
                    <canvas id="realtimeregchart" width="600" height="400"></canvas>
                  </ng-template>
                  </div>
                  </div>
                </div>

                <div class="card-body" [hidden]="!ismonthReg">
                  <div class="chart-mob-scroll cm-scrollbar">
                  <div class="chartAreaWrapper">
                  <canvas *ngIf="!deviceService.isMobile() else mobileRealtimeRegmonth"  id='realtimeregchartmonth' width="200" height="50"></canvas>
                  <ng-template #mobileRealtimeRegmonth>
                        <canvas id="realtimeregchartmonth" width="600" height="300"></canvas>
                  </ng-template>
                </div>
                </div>
              </div>

              <div class="card-body" [hidden]="!isweekReg">
                <div class="chart-mob-scroll cm-scrollbar">
                <div class="chartAreaWrapper">
                <canvas *ngIf="!deviceService.isMobile() else mobileRealtimeRegweek"  id='realtimeregweek' width="200" height="50"></canvas>
                <ng-template #mobileRealtimeRegweek>
                      <canvas id="realtimeregweek" width="600" height="300"></canvas>
                </ng-template>
              </div>
              </div>
            </div>
              </div>
            </section>
          </div>




</div>
</section>
</div>

